import { render } from "./GrowthModel.vue?vue&type=template&id=4812bb54"
import script from "./GrowthModel.vue?vue&type=script&lang=js"
export * from "./GrowthModel.vue?vue&type=script&lang=js"

import "./GrowthModel.vue?vue&type=style&index=0&id=4812bb54&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__